import {legacy_createStore as createStore} from "redux";
import rootReducer from "../reducers";

const store = createStore(rootReducer);

export default store;

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof createStore>
export type AppDispatch = AppStore['dispatch']
